import { createContext } from 'react';
import { DashboardCompaniesContextProps } from './DashboardCompanies.types';

export const DashboardCompaniesContext = createContext<DashboardCompaniesContextProps>(
  {} as DashboardCompaniesContextProps
);
